import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {DataSource} from '@angular/cdk/collections';
import {MdPaginator, MdSnackBar, PageEvent} from '@angular/material';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import { Configurations } from "../../core/configurations";
import { ZonaSearchModel } from './../../models/user/zona-search.model';
import { ZonaListItemModel } from './../../models/user/zona-list-item.model';
import { ZoneService } from './../../services/zone.service';
import { AuthService} from './../../services/auth.service';
import { UserModel } from '../../models/user/user.model';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BloccoModel } from '../../models/dashboard/blocco.model';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-zone-utent-list',
  templateUrl: './zone-utente-list.component.html',
  styleUrls: ['./zone-utente-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ZoneUtenteListComponent implements OnInit {

  isLoading = false;
  zone: ZonaListItemModel[];
  model: ZonaSearchModel = null;
  dataSource: ZoneDataSource = null;
  displayedColumns = ['id','codice', 'descrizione'];
  numeroRisultati=0;
  pageEvent: PageEvent;
  numeroPagine: number=0;
  user: UserModel;

  @ViewChild(MdPaginator) paginator: MdPaginator;

  constructor(
    private configuration: Configurations,
    private zoneService: ZoneService,
    private authService: AuthService,
    private snackBar: MdSnackBar,
    private _authService: AuthService,    
    private _dashboardService: DashboardService
  )  {
    this.user = this._authService.user;
   }

  ngOnInit() {
    this.model = new ZonaSearchModel();
  }

  //RICERCA
  search() { 
    this.numeroRisultati=0;
    this.isLoading = true;

    this.model.pageNumber = this.paginator.pageIndex+1;
    this.model.pageSize=this.paginator.pageSize;
    
    this.zoneService.getListaZone(this.model)
    .finally(() => this.isLoading = false)
    .subscribe((r: any) => {
      
      this.zone = r.zoneTrovate as ZonaListItemModel[];
      this.dataSource = new ZoneDataSource(this.zone, this.paginator, this.model);
      this.numeroRisultati= this.zone.length;
      this.numeroPagine= r.numeroPagineTotali;
      
    },
    (err)=>{
      this.showError("Errore durante la procedura di ricerca e caricamento delle zone.")
    });
  }
 

  //PAGINAZIONE
  onPaginateChange(event){
    this.model.pageNumber = this.paginator.pageIndex+1;
    this.model.pageSize=this.paginator.pageSize;
    this.search();
  }
  
  //MSG
  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 3000 });
  }

}

////////////////////////////////////////////////////////////
//DATASOURCE
export class ZoneDataSource extends DataSource<any> {
   isLoading = false;

    constructor(private data: ZonaListItemModel[], private _paginator: MdPaginator, private model: ZonaSearchModel) {
      super();
    }
    connect(): Observable<ZonaListItemModel[]> {

      return Observable.of(this.data);
    }

    disconnect() {}

  }



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utenti/zone-utente-list.component.ts